
import React, { Suspense, lazy, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import AppLayout from './components/AppLayout';
import PublicLayout from './components/PublicLayout';
import { SubscriptionProvider } from './context/SubscriptionContext';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './screens/Home';

const About = lazy(() => import('./screens/About'));
const CoreSolutions = lazy(() => import('./screens/CoreSolutions'));
const Conferences = lazy(() => import('./screens/Conferences'));
const Contact = lazy(() => import('./screens/Contact'));
const Deals = lazy(() => import('./screens/Deals'));
const Dashboard = lazy(() => import('./screens/Dashboard'));
const FreshGoods = lazy(() => import('./screens/FreshGoods'));
const MarketResearch = lazy(() => import('./screens/MarketResearch'));
const Industries = lazy(() => import('./screens/Industries'));
const Individuals = lazy(() => import('./screens/Individuals'));
const LatestNews = lazy(() => import('./screens/LatestNews'));
const Login = lazy(() => import('./screens/Login'));
const News = lazy(() => import('./screens/News'));
const Products = lazy(() => import('./screens/Products'));
const Register = lazy(() => import('./screens/Register'));
const ForgotPassword = lazy(() => import('./screens/ForgotPassword'));
const Onboarding = lazy(() => import('./screens/Onboarding'));
const Sandbox = lazy(() => import('./screens/Sandbox'));
const Settings = lazy(() => import('./screens/Settings'));
const Support = lazy(() => import('./screens/Support'));
const AdminTickets = lazy(() => import('./screens/AdminTickets'));
const LockedDataset = lazy(() => import('./screens/LockedDataset'));

function App() {
  const [showSplash, setShowSplash] = useState(true);

  return (
    <AuthProvider>
    <SubscriptionProvider>
      <BrowserRouter>
        <Suspense fallback={<div style={{padding: 48, textAlign: 'center'}}>Loading…</div>}>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={showSplash ? <Home onEnter={() => setShowSplash(false)} /> : <Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/core-solutions" element={<CoreSolutions />} />
              <Route path="/products" element={<Products />} />
              <Route path="/news" element={<News />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
            <Route path="/app" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="fresh-goods" element={<FreshGoods />} />
              <Route path="market-research" element={<MarketResearch />} />
              <Route path="sandbox" element={<Sandbox />} />
              <Route path="settings" element={<Settings />} />
              <Route path="industries" element={<Industries />} />
              <Route path="deals" element={<Deals />} />
              <Route path="individuals" element={<Individuals />} />
              <Route path="latest-news" element={<LatestNews />} />
              <Route path="conferences" element={<Conferences />} />
              <Route path="support" element={<Support />} />
              <Route path="admin-tickets" element={<AdminTickets />} />
              <Route path="automotive" element={<LockedDataset />} />
              <Route path="real-estate" element={<LockedDataset />} />
              <Route path="energy" element={<LockedDataset />} />
              <Route path="technology" element={<LockedDataset />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </SubscriptionProvider>
    </AuthProvider>
  );
}

export default App;
